// extracted by mini-css-extract-plugin
export default {"formContainer":"ListAlerts_formContainer__5SlaA"};